module.exports = __webpack_public_path__ + "proximanova-regular-webfont.1a6ef4dfcf20dc6d631f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/proximanova-regular-webfont.woff
// module id = 253
// module chunks = 2